export type MarketingFeature = {
  audience: 'personal' | 'business'
  slug: string
  icon: string
  title: string
  menuDescription: string
  description: string
  href: string
}

export const personalMarketingFeatures: MarketingFeature[] = [
  {
    audience: 'personal',
    slug: 'digital-invitations',
    icon: '✉',
    title: 'Digital Invitations',
    menuDescription: 'Beautiful, shareable invitations for every occasion.',
    description: 'Create invitations your guests will actually open and respond to from one simple link.',
    href: '/personal/features/digital-invitations',
  },
  {
    audience: 'personal',
    slug: 'rsvp-management',
    icon: '✓',
    title: 'RSVP Management',
    menuDescription: 'Know who is attending without spreadsheets.',
    description: 'Turn every reply into a clearer event plan with real-time guest response tracking.',
    href: '/personal/features/rsvp-management',
  },
  {
    audience: 'personal',
    slug: 'video-wishes',
    icon: '▶',
    title: 'Video Wishes',
    menuDescription: 'Collect heartfelt messages from anywhere.',
    description: 'Bring every voice into the celebration with simple browser-based video contributions.',
    href: '/personal/features/video-wishes',
  },
  {
    audience: 'personal',
    slug: 'event-photo-sharing',
    icon: '▣',
    title: 'Photo & Video Sharing',
    menuDescription: 'One shared gallery from every guest phone.',
    description: 'Let every guest capture a piece of the celebration and send it to one gallery.',
    href: '/personal/features/event-photo-sharing',
  },
  {
    audience: 'personal',
    slug: 'live-event-wall',
    icon: '▤',
    title: 'Live Event Slideshow',
    menuDescription: 'Display guest memories live on any screen.',
    description: 'Turn any screen into the heart of the celebration with real-time guest moments.',
    href: '/personal/features/live-event-wall',
  },
  {
    audience: 'personal',
    slug: 'event-qr-codes',
    icon: '⌗',
    title: 'Event QR Codes',
    menuDescription: 'One scan connects guests to the event.',
    description: 'Give guests instant access to RSVP, uploads, wishes, and event details.',
    href: '/personal/features/event-qr-codes',
  },
  {
    audience: 'personal',
    slug: 'gift-vibevite',
    icon: '◇',
    title: 'Gift VibeVite',
    menuDescription: 'Give someone the tools for a beautiful celebration.',
    description: 'Send a VibeVite plan as a thoughtful digital gift for someone else to celebrate.',
    href: '/personal/features/gift-vibevite',
  },
  {
    audience: 'personal',
    slug: 'live-streaming',
    icon: '◉',
    title: 'Live Streaming',
    menuDescription: 'Help distant guests feel present in real time.',
    description: 'Share the moment with guests anywhere through a live stream tied to the event.',
    href: '/personal/features/live-streaming',
  },
]

export const businessMarketingFeatures: MarketingFeature[] = [
  {
    audience: 'business',
    slug: 'employee-recognition-walls',
    icon: '★',
    title: 'Employee Recognition Walls',
    menuDescription: 'Celebrate people and achievements together.',
    description: 'Give appreciation a place the whole team can share with messages, media, and recognition.',
    href: '/business/features/employee-recognition-walls',
  },
  {
    audience: 'business',
    slug: 'milestone-templates',
    icon: '◆',
    title: 'Milestone Templates',
    menuDescription: 'Launch workplace celebrations faster.',
    description: 'Start every workplace moment with the right structure and visual tone.',
    href: '/business/features/milestone-templates',
  },
  {
    audience: 'business',
    slug: 'multimedia-contributions',
    icon: '▶',
    title: 'Multimedia Contributions',
    menuDescription: 'Messages, GIFs, photos, audio, and video.',
    description: 'Let every colleague contribute in the format that feels natural to them.',
    href: '/business/features/multimedia-contributions',
  },
  {
    audience: 'business',
    slug: 'team-invitations-reminders',
    icon: '✉',
    title: 'Invitations & Reminders',
    menuDescription: 'Invite contributors and follow up with ease.',
    description: 'Get the right people contributing before reveal day without manual follow-up chaos.',
    href: '/business/features/invitations-reminders',
  },
  {
    audience: 'business',
    slug: 'moderation-admin-controls',
    icon: '⌘',
    title: 'Moderation & Admin',
    menuDescription: 'Keep contributions appropriate and organized.',
    description: 'Give organizers control without slowing participation across business celebrations.',
    href: '/business/features/moderation-admin',
  },
  {
    audience: 'business',
    slug: 'sso-access-control',
    icon: '⌁',
    title: 'SSO & Access Control',
    menuDescription: 'Enterprise-ready identity and secure access.',
    description: 'Support enterprise access expectations with stronger identity and governance options.',
    href: '/business/features/sso-access-control',
  },
]